import './CardEmployeeComponentStyles.scss';
import { FC } from "react";
import { useNavigate } from "react-router-dom";
import CardEmployeeComponentProps from "./CardEmployeeComponentProps";
import UserNameWithPhotoComponent from '../userNameWithPhoto/UserNameWithPhotoComponent';
import UserContactInformationComponent from '../userContactInformation/UserContactInformationComponent';
import { UserEntityStatus } from '../../../../../../domain/entities/UserEntity';
import Button from "@cloudscape-design/components/button";

function capitalizeFirstLetter(str: string) {
    return str.replace(/\b\w/g, function(char) {
        return char.toUpperCase();
    });
}


const CardEmployeeComponent: FC<CardEmployeeComponentProps> = ({ employee, onClick }) => {
    const navigate = useNavigate();

    // Determine active status:
    // - If status field is explicitly 'deleted', it's inactive
    // - If is_active field is explicitly 0, it's inactive
    // - Otherwise default to active (the /users API only returns active users)
    const isActive = employee.status === UserEntityStatus.active ||
        (employee.status !== UserEntityStatus.deleted && (employee as any).is_active !== 0 && (employee as any).is_active !== false);

    const handleProfileClick = (e: CustomEvent) => {
        e.stopPropagation();
        navigate(`/users/${employee.id}/profile`);
    };

    return <div className="card-employee-component" onClick={() => onClick(employee)}>
        <div className="card-body">
            <div className="card-header-row">
                <span className={`status-badge ${isActive ? 'status-active' : 'status-inactive'}`}>
                    {isActive ? 'Active' : 'Inactive'}
                </span>
                <Button variant="icon" iconName="user-profile" onClick={handleProfileClick} ariaLabel="View profile" />
            </div>
            <UserNameWithPhotoComponent
                image={employee.image as string}
                title={capitalizeFirstLetter(employee.name || `${employee.firstname || ''} ${employee.lastname || ''}`.trim())}
                subtitle={employee.position || ''}
                description={(employee.area ? employee.area + " - " : " ") + (employee?.role?.name || (employee as any)?.role_name || '')}
            />
            <UserContactInformationComponent information01={employee.email} information02={employee.phone} />
        </div>
    </div>
}

export default CardEmployeeComponent;